'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const Formatters=require('../../../dist-es6/client/formatters');let

TimeFormattingService=function(_BaseService){_inherits(TimeFormattingService,_BaseService);_createClass(TimeFormattingService,null,[{key:'$inject',get:function()
{
return['displaySettingsService','timeZoneService'];
}}]);

function TimeFormattingService(displaySettingsService,timeZoneService){_classCallCheck(this,TimeFormattingService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._displaySettingsService=displaySettingsService;
_this._timeZoneService=timeZoneService;return _this;
}TimeFormattingService.prototype.





timeInLocale=function timeInLocale(time,timezone){let displayTimeZone=arguments.length>2&&arguments[2]!==void 0?arguments[2]:!0;
return Formatters.timeInLocale(time,timezone,displayTimeZone,this.safeUse24HourTimelineSetting);
};TimeFormattingService.prototype.

timeAndFullDateInTimezone=function timeAndFullDateInTimezone(time,timezone){
return Formatters.timeAndFullDateInTimeZone(time,timezone,this.safeUse24HourTimelineSetting);
};TimeFormattingService.prototype.

timeAndFullDateInLocalTime=function timeAndFullDateInLocalTime(time){
return Formatters.timeAndFullDateInTimeZone(time,this._timeZoneService.localTimeZone,this.safeUse24HourTimelineSetting);
};_createClass(TimeFormattingService,[{key:'safeUse24HourTimelineSetting',get:function(){return _.get(this._displaySettingsService,'use24HourTimeline',!1)}}]);return TimeFormattingService}(BaseService);


module.exports=TimeFormattingService;
//# sourceMappingURL=timeFormattingService.js.map
